import React from 'react';
import { observer } from 'mobx-react';
import { NeoModel, Validation } from '@singularsystems/neo-core';
import { IQuestionnaireComponentProps, QuestionnaireComponentVMBase, QuestionsComponent, UpdateQuestionnaireAnswerCommand } from 'st-common/Awards';
import { Neo } from '@singularsystems/neo-react';

interface ISurveyQuestionnaireComponentProps extends IQuestionnaireComponentProps<SurveyQuestionnaireComponentComponentVM> {
}

@NeoModel
export class SurveyQuestionnaireComponentComponentVM extends QuestionnaireComponentVMBase {

    public onAnswersSaved?: () => void;

    public validationDisplayMode: Validation.DisplayMode | undefined;

    protected afterSave(command: UpdateQuestionnaireAnswerCommand) {
        super.afterSave(command);

        if (this.onAnswersSaved) {
            this.onAnswersSaved();
        }
    }
}

@observer
export default class SurveyQuestionnaireComponent extends React.Component<ISurveyQuestionnaireComponentProps> {
    public render() {
        const viewModel = this.props.viewModel;
        return (<div>
            <div className="p-3">
                <Neo.Form model={viewModel.updateQuestionnaireAnswerCommand.questionnaireAnswered} validationDisplayMode={viewModel.validationDisplayMode}>
                    <QuestionsComponent questionnaireAnswered={viewModel.updateQuestionnaireAnswerCommand.questionnaireAnswered}
                        disabled={this.props.disabled} />
                </Neo.Form>
            </div>
        </div>);
    }
}